"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const InstagramIcon = createIcon({
  displayName: "InstagramIcon",
  viewBox: "0 0 45 45",
  path: (
    <>
      <path
        d="M22.51,10.95c-6.38,0-11.55,5.17-11.55,11.55s5.17,11.55,11.55,11.55,11.55-5.17,11.55-11.55-5.17-11.55-11.55-11.55ZM22.51,29.99c-4.14,0-7.49-3.35-7.49-7.49s3.35-7.49,7.49-7.49,7.49,3.35,7.49,7.49c0,4.14-3.35,7.49-7.49,7.49Z"
        fill="currentColor"
      />
      <path
        d="M31.78.14C27.64-.05,17.38-.04,13.24.14c-3.64.17-6.85,1.05-9.44,3.64C-.53,8.11.02,13.94.02,22.49s-.49,14.45,3.77,18.71c4.34,4.34,10.26,3.77,18.71,3.77s11.66,0,14.73-1.18c4.17-1.62,7.31-5.34,7.62-12.04.19-4.14.18-14.39,0-18.54-.37-7.9-4.61-12.69-13.08-13.08ZM38.33,38.34c-2.84,2.84-6.77,2.58-15.88,2.58s-13.13.14-15.88-2.61c-3.16-3.14-2.59-8.19-2.59-15.85C3.99,12.1,2.93,4.64,13.32,4.11c2.39-.08,3.09-.11,9.1-.11l.08.06c9.99,0,17.83-1.05,18.3,9.35.11,2.37.13,3.08.13,9.09,0,9.27.17,13.05-2.61,15.85Z"
        fill="currentColor"
      />
      <path
        d="M34.51,13.19c1.49,0,2.7-1.21,2.7-2.7s-1.21-2.7-2.7-2.7-2.7,1.21-2.7,2.7,1.21,2.7,2.7,2.7Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default InstagramIcon;
